import { z } from 'zod';

export const InspirationOptionSchema = z.object({
  type: z.literal('inspiration'),
  id: z.string(),
  isActive: z.boolean(),
});

export const CollectionOptionSchema = z.object({
  type: z.literal('collection'),
  id: z.string(),
  isActive: z.boolean(),
});

export const AdminOptionSchema = z.discriminatedUnion('type', [
  InspirationOptionSchema,
  CollectionOptionSchema,
]);

export type PublicInspirationProject = z.infer<typeof InspirationOptionSchema>;
export type PublicCollectionProject = z.infer<typeof CollectionOptionSchema>;
export type PublicAdminOption = z.infer<typeof AdminOptionSchema>;
